import { postRawRequest } from '../../httpClient';

export async function reprocessTimingApi(dryRun = false): Promise<Response> {
  return postRawRequest({
    path: `/sys/pipeline/reprocess-timing${dryRun ? '?dryRun=true' : ''}`,
    options: { timeout: 300_000 },
  });
}
